<template>
  <div class="login">
    <form class="form" @submit.prevent="handleSubmit">
      <div class="form__img">
        <img alt="logo" src="../assets/logo_quick_pay_2022.png" />
        <p>Compra en tus tiendas favoritas</p>
        <span>Más facil, rápido y seguro</span>
      </div>
      <div class="form__inputs">
        <div class="input">
          <input
            type="text"
            placeholder="Correo"
            v-model="email"
            style="outline: none"
          />
          <i class="far fa-user-circle"></i>
        </div>

        <div class="input">
          <input
            class="reveal"
              :type='show?"text":"password"'
              placeholder="Clave"
            v-model="password"
            style="outline: none"
          />
          <p @click="showPasswrd" style="margin-bottom: 0px">
            <a class="fas fa-eye"></a>
          </p>
        </div>

        <div class="remember_account">
          <p>Recordar mi cuenta</p>
          <span><input type="checkbox"  v-model="remember" @click="savecaount"/> </span>
        </div>
        <button>Ingresar</button>
<!--        <div style="text-align: center">-->
<!--          <p>¿No tienes cuenta? <a href="#" @click="register">Regístrate</a></p>-->
<!--        </div>-->
        <div style="text-align: center">
          <a href="#" @click="passwordrecovery">Restablecer contraseña</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  // @ is an alias to /src
  import axios from 'axios'

  export default {
    name: 'Login',
    components: {},
    data() {
      return {
        cellphone: '',
        email: '',
        password: '',
        show: false,
        remember: false,
        url: ''
      }
    },
    mounted() {
      const gmail = 'gmail'
      const password = 'password'
      const checkbox = 'checkbox'
      if( document.cookie.length > 0 ){
        let start = document.cookie.indexOf(gmail + '=');
        if( start !== -1 ){
          start = start + gmail.length + 1;
          let end = document.cookie.indexOf(';', start);
          if( end === -1 ){
            end = document.cookie.length;
            this.email = Base64.decode(document.cookie.substring(start, end))
          } else{
            this.email = document.cookie.substring(start, end)
          }
        }
      }
      if( document.cookie.length > 0 ){
        let start = document.cookie.indexOf(password + '=');
        if( start !== -1 ){
          start = start + password.length + 1;
          let end = document.cookie.indexOf(';', start);
          if( end === -1 ){
            end = document.cookie.length;
            this.password = document.cookie.substring(start, end)
          } else{
            this.password = document.cookie.substring(start, end)
          }
        }
      }
      if( document.cookie.length > 0 ){
        let start = document.cookie.indexOf(checkbox + '=');
        if( start !== -1 ){
          start = start + checkbox.length + 1;
          let end = document.cookie.indexOf(';', start);
          if( end === -1 ){
            end = document.cookie.length;
            if (document.cookie.substring(start, end) === 'false'){
              this.remember = true
            }else {
              this.remember = false
            }
          } else{
            if (document.cookie.substring(start, end) === 'false'){
              this.remember = true
            }else {
              this.remember = false
            }
          }
        }
      }
    },
    methods: {
      showPasswrd(){
        if(this.show === true){
          this.show = false
        }else {
          this.show = true
        }
      },
      register() {
        this.$router.push('/register')
      },
      passwordrecovery() {
        this.$router.push('/passwordrecovery')
      },
      savecaount(){
        if (this.remember===false){
          document.cookie=  'gmail='+ this.email
          document.cookie= 'password='+ this.password
        }else {
          document.cookie=  'gmail= '
          document.cookie= 'password= '
        }
        document.cookie = 'checkbox=' +this.remember

      },
      cookieAccount(gmail, password){
        if( document.cookie.length > 0 ){
          let start = document.cookie.indexOf(gmail + '=');
          if( start !== -1 ){
            start = start + gmail.length + 1;
            let end = document.cookie.indexOf(';', start);
            if( end === -1 ){
              end = document.cookie.length;
              this.email = Base64.decode(document.cookie.substring(start, end))
            } else{
              this.email = document.cookie.substring(start, end)
            }
          }
        }
        if( document.cookie.length > 0 ){
          let start = document.cookie.indexOf(password + '=');
          if( start !== -1 ){
            start = start + password.length + 1;
            let end = document.cookie.indexOf(';', start);
            if( end === -1 ){
              end = document.cookie.length;
              this.password = document.cookie.substring(start, end)
            } else{
              this.password = document.cookie.substring(start, end)
            }
          }
        }
      },
      getEmpresa(token, url){
        console.log(token);
         axios.get("general/elements/empresa",{params: {
        },headers: {
          'Authorization': `Bearer `+ token
        }}).then( res => {
          console.log(res);
          const cellphone = res.data.data[0];
          this.cellphone = cellphone.valor;
          localStorage.setItem("cellphone", this.cellphone);   
           window.location.href = url   
        });
      },
      async handleSubmit() {
        const response = await axios.post('login', {
          email: this.email,
          password: this.password,
          isWeb: 1
        })

        if (typeof response.data.message === 'undefined') {
          localStorage.setItem('company_id', response.data.user.company_id)
          localStorage.setItem('id', response.data.user.id)
          localStorage.setItem('company_name', response.data.company.company_name)
          localStorage.setItem('token', response.data.access_token)
          localStorage.setItem('modal', false)
          localStorage.setItem(
              'usuario',
              response.data.user.user_name +
              ' ' +
              response.data.user.user_lastname
          )
          if (response.data.user.role_id === 2) {
            this.getListOfMenu(response.data.user.role_id)
            localStorage.setItem('role', 'cliente')
            this.$swal({
              position:'center',
              icon: 'success',
              title: 'Bienvenido',
              showConfirmButton: false,
              timer: 2000
            })
            // this.$router.push('/')
            this.url = "/";
          } else if (response.data.user.role_id === 3) {
            localStorage.setItem('role', 'admin')
            localStorage.removeItem('admin_in_company')
            this.getListOfMenu(response.data.user.role_id)
            this.$swal({
              position:'center',
              icon: 'success',
              title: 'Bienvenido',
              showConfirmButton: false,
              timer: 2000
            })
            this.url = "/comercial";
          } else {
            //
          }
           this.getEmpresa(response.data.access_token,  this.url)
        }else{
          let error = ''

          if (this.email === ''){
            error = 'Completar el campo correo'
          }else if(this.password === ''){
            error = 'Completar el campo clave'
          }else{
            error = response.data.message
          }
          this.$swal({
            position: 'center',
            icon: 'error',
            title: error,
            showConfirmButton: false,
            timer: 2000
          })
        }
      },

      getListOfMenu(role_id) {
        // let base_url = "http://192.168.1.16:8080/Client/";
        const client_list = [
          { id: 1, path: '/', name: 'Datos comerciales', class: 'active' },
          {
            id: 2,
            path: '/Client/cp-productos',
            name: 'Conciliación Operativa',
            class: ''
          },
          { id: 3, path: '#', name: 'Conciliación Contable', class: '' },
          {
            id: 4,
            path: '/Client/ic-operativo-contable',
            name: 'Incidencias',
            class: ''
          },
          {
            id: 5,
            path: '/Client/id-productos',
            name: 'Indicadores',
            class: ''
          },
          {
            id: 6,
            path: '/mesas',
            name: 'Servicio de mesa',
            class: ''
          }
        ]
        const admin_list = [
          { id: 1, path: '/comercial', name: 'Datos Comerciales', class: 'active' },
          { id: 2, path: '/incidencias', name: 'Incidencias', class: ''},
          { id: 3, path: '/InboxSugerences', name: 'Buzón de sugerencias', class: ''},
          { id: 4, path: '/ClientesB2C', name: 'Clientes', class: '' },
          { id: 5, path: '/UsuariosB2B', name: 'Usuarios', class: '' },
          { id: 6, path: '/Indicators/productos', name: 'Indicadores', class: '' },
          { id: 7, path: '/CargaArchivos', name: 'Conciliación', class: '' },
        ]
        let list = role_id === 2 ? client_list : admin_list
        localStorage.setItem('getListOfMenu', JSON.stringify(list))
      }
      // auth(){
      //   this.$router.push('/home');
      // }
    }
  }
</script>

<style scoped>
  /*------LOGIN------*/
  .login {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Readex Pro', sans-serif;
  }

  .form {
    width: 500px;
    height: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 768px) {
    .form {
      width: 390px;
      height: 600px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .form__img {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .form__img img {
    width: 300px;
  }

  .form__img p {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #ff3128;
  }

  .form__img span {
    margin: 0;
    font-size: 15px;
    font-weight: 300;
  }

  .form__inputs {
    width: 100%;
    height: 100%;
    display: flex;
    margin-top: 20px;
    flex-direction: column;
  }

  .form__inputs .input {
    width: 90%;
    margin: 10px auto;
    border: 1px solid #f1f1f1;
    border-radius: 15px;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .form__inputs .input input {
    border: none;
    width: 100%;
  }

  .form__inputs button {
    width: 90%;
    margin: 10px auto;
    border: none;
    border-radius: 10px;
    background: #ff3128;
    color: #fff;
    padding: 15px 10px;
    font-weight: 600;
  }

  .form__inputs .remember_account {
    width: 85%;
    margin: 15px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .form__inputs .remember_account p {
    margin: 0;
  }
::-ms-reveal{
    display: none;
}
  /*------LOGIN------*/
</style>
